<ng-container *ngFor="let key of carrierKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: carrierLookup : carrierWithLookup[key] ?? null"
  ></div>
</ng-container>
